import { useState } from 'react';
import { useRevalidator } from 'react-router';
import { api } from '@/lib/api';

export function ExampleToggle({ templateId, isExample }: { templateId: string; isExample: boolean }) {
  const { revalidate } = useRevalidator();
  const [busy, setBusy] = useState(false);
  return (
    <label className="flex items-center gap-2 text-xs">
      <input
        type="checkbox"
        checked={isExample}
        disabled={busy}
        onChange={async (e) => {
          setBusy(true);
          try {
            await api(`/templates/${templateId}`, { method: 'PATCH', json: { isExample: e.target.checked } });
            revalidate();
          } finally {
            setBusy(false);
          }
        }}
      />
      use as example
    </label>
  );
}
